exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-957f0c6c","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/www/newcode/platform-admin/src/style/theme.scss","/data/www/newcode/platform-admin/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 862
// module chunks = 30